"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SYSTEM_ROLE_PERMISSIONS_TEMPLATE = exports.SAMPLE_TEST_BATCH_COMMENTS_TEMPLATE = exports.USER_TEMPLATE = exports.DTBA = exports.DatabaseTables = void 0;
const constants_1 = require("./constants");
const permissions_1 = require("./permissions");
var DatabaseTables;
(function (DatabaseTables) {
    DatabaseTables["USERS"] = "Users";
    DatabaseTables["COMPANY"] = "Company";
    DatabaseTables["ADMIN_EMAIL"] = "AdminEmail";
    DatabaseTables["ORDERS"] = "Orders";
    DatabaseTables["ADMIN_LOGS"] = "Admin_Logs";
    DatabaseTables["ORGANIZATION_LICENSE"] = "Organization_License";
    DatabaseTables["SAMPLE_SPECIFICATIONS"] = "Cannabis_Sample_Specifications";
    DatabaseTables["SAMPLE_SPECIFICATION_DIRECTORY"] = "Sample_Specification_Directory";
    DatabaseTables["SAMPLE_SPECIFICATION_READING_FILE"] = "Sample_Specification_Reading_File";
    DatabaseTables["SAMPLE_SPECIFICATION_READING_INFO"] = "Sample_Specification_Reading_Info";
    DatabaseTables["CLIENTS"] = "Clients";
    DatabaseTables["SAMPLES"] = "Cannabis_Samples";
    DatabaseTables["SAMPLE_INSTANCE"] = "Cannabis_Sample_Instance";
    DatabaseTables["SAMPLE_TEST_BATCH"] = "Cannabis_Sample_Test_Batch";
    DatabaseTables["SAMPLE_TEST_BATCH_ASSIGNED_USERS"] = "Sample_Test_Batch_Assigned_Users";
    DatabaseTables["SAMPLE_TEST_BATCH_COMMENTS"] = "Sample_Test_Batch_Comments";
    DatabaseTables["CLIENT_ORGANIZATION"] = "Client_Organization";
    DatabaseTables["TEST_METHODS"] = "Cannabis_Test_Methods";
    DatabaseTables["BATCH_REPORT_FILES"] = "Cannabis_Batch_Report_Files";
    //reconstructions
    DatabaseTables["COMPANY_TEST_CATEGORIES"] = "Company_Test_Categories";
    DatabaseTables["COMPANY_SAMPLE_MATRIX"] = "Company_Sample_Matrix";
    DatabaseTables["COMPANY_TEST_HIERARCHY_NODES"] = "Company_Test_Hierarchy_Nodes";
    DatabaseTables["COMPANY_TEST_PACKAGE"] = "Company_Test_Package";
    DatabaseTables["COMPANY_TEST_PACKAGE_TESTS"] = "Company_Test_Package_Tests";
    DatabaseTables["COMPANY_SAMPLE_ADDITIONAL_INFO_FIELDS"] = "Company_Sample_Additional_Info_Fields";
    DatabaseTables["SAMPLE_ADDITIONAL_INFO_MAPPING"] = "Sample_Additional_Info_Mapping";
    DatabaseTables["SAMPLE_INSTANCE_ADDITIONAL_INFO_MAPPING"] = "Sample_Instance_Additional_Info_Mapping";
    DatabaseTables["SAMPLE_INSTANCE_TEST_AND_BATCH_ASSIGNMENT"] = "Sample_Instance_Test_And_Batch_Assignment";
    DatabaseTables["COMPANY_BATCH_TYPES"] = "Company_Batch_Types";
    DatabaseTables["COMPANY_BATCH_TYPE_TEST_CATEGORY_MAPPING"] = "Company_Batch_Type_Test_Category_Mapping";
    DatabaseTables["COMPANY_BATCH_TYPE_HIERARCHY_TEST_NODE_MAPPING"] = "Company_Batch_Type_Hierarchy_Test_Node_Mapping";
    DatabaseTables["COMPANY_BATCH_TYPE_TEST_GROUP_OPTION_NODE_MAPPING"] = "Company_Batch_Type_Test_Group_Option_Node_Mapping";
    DatabaseTables["ANALYST_CUSTOM_GROUP"] = "Analyst_Custom_Group";
    DatabaseTables["ANALYST_GROUP_BATCH_PERMISSION_ASSIGNMENT"] = "Analyst_Group_Batch_Permission_Assignment";
    DatabaseTables["ANALYST_GROUP_PERMITTED_OTHER_TEST_CATEGORIES"] = "Analyst_Group_Permitted_Other_Test_Categories";
    //labels
    DatabaseTables["COMPANY_TEST_LABELS"] = "Company_Test_Labels";
    DatabaseTables["COMPANY_TEST_LABEL_SETTINGS"] = "Company_Test_Label_Settings";
    DatabaseTables["COMPANY_TEST_LABEL_SECONDARY_LABELS"] = "Company_Test_Label_Secondary_Labels";
    DatabaseTables["COMPANY_TEST_LABEL_PACKAGE_ASSIGNMENT"] = "Company_Test_Label_Package_Assignment";
    //to be removed
    // COMPANY_TEST_LABEL_HIERARCHY_NODE_MAPPING_PACKAGE = "Company_Test_Label_Hierarchy_Node_Mapping_Package",
    // COMPANY_TEST_LABEL_PACKAGE_HIERARCHY_NODE_MAPPING = "Company_Test_Label_Package_Hierarchy_Node_Mapping",
    //test results
    DatabaseTables["COMPANY_TEST_RESULT_UNITS"] = "Company_Test_Result_Units";
    DatabaseTables["COMPANY_RESULT_UNIT_ASSIGNMENT"] = "Company_Result_Unit_Assignment";
    DatabaseTables["COMPANY_TEST_RESULT_FIELDS"] = "Company_Test_Result_Fields";
    DatabaseTables["COMPANY_TEST_EXPECTATION_FIELDS"] = "Company_Test_Expectation_Fields";
    DatabaseTables["TEST_EXPECTATIONS"] = "Test_Expectations";
    DatabaseTables["COMPANY_HIERARCHY_NODE_MAPPING_PACKAGE"] = "Company_Hierarchy_Node_Mapping_Package";
    DatabaseTables["COMPANY_PACKAGE_HIERARCHY_NODE_MAPPING"] = "Company_Package_Hierarchy_Node_Mapping";
    DatabaseTables["COMPANY_TEST_RESULT_PACKAGE_ASSIGNMENT"] = "Company_Test_Result_Package_Assignment";
    //workflows
    DatabaseTables["COMPANY_TESTING_WORKFLOW"] = "Company_Testing_Workflow";
    DatabaseTables["COMPANY_TESTING_WORKFLOW_BATCH_TYPE_ASSIGNMENT"] = "Company_Testing_Workflow_Batch_Type_Assignment";
    DatabaseTables["COMPANY_TESTING_WORKFLOW_STEPS"] = "Company_Testing_Workflow_Steps";
    DatabaseTables["COMPANY_TESTING_WORKFLOW_TRANSITIONS"] = "Company_Testing_Workflow_Transitions";
    DatabaseTables["COMPANY_TESTING_WORKFLOW_INFO_HIERARCHY_NODES"] = "Company_Testing_Workflow_Info_Hierarchy_Nodes";
    DatabaseTables["COMPANY_TESTING_WORKFLOW_INFO_NODES_RENDER_CONDITIONS"] = "Company_Testing_Workflow_Info_Nodes_Render_Conditions";
    DatabaseTables["COMPANY_TESTING_WORKFLOW_INFO_FIELDS"] = "Company_Testing_Workflow_Info_Fields";
    DatabaseTables["COMPANY_WORKFLOW_NODE_INFO_ASSIGNMENT"] = "Company_Workflow_Node_Info_Assignment";
    DatabaseTables["COMPANY_TESTING_WORKFLOW_INFO_OPTIONS"] = "Company_Testing_Workflow_Info_Options";
    DatabaseTables["COMPANY_RESULT_CALCULATION_FORMULA"] = "Company_Result_Calculation_Formula";
    DatabaseTables["COMPANY_RESULT_CALCULATION_FORMULA_COMPONENTS"] = "Company_Result_Calculation_Formula_Components";
    DatabaseTables["COMPANY_WORKFLOW_RESULT_FORMULA_ASSIGNMENT"] = "Company_Workflow_Result_Formula_Assignment";
    DatabaseTables["BATCH_WORKFLOW_SIGNATURE"] = "Batch_Workflow_Signature";
    DatabaseTables["BATCH_INSTANCE_LAB_WORKFLOW_INFO"] = "Batch_Instance_Lab_Workflow_Info";
    DatabaseTables["TEST_RESULTS"] = "Test_Results";
    DatabaseTables["TEST_RESULT_PACKAGE"] = "Test_Result_Package";
    //TEMP
    //specs
    DatabaseTables["COMPANY_SAMPLE_SPECIFICATION_HEADERS"] = "Company_Sample_Specification_Headers";
    DatabaseTables["COMPANY_SAMPLE_SPECIFICATION_ROW"] = "Company_Sample_Specification_Row";
    //temp
    DatabaseTables["TEMP_FILE_PASSWORD_MANAGEMENT"] = "Temp_File_Password_Management";
    //permissions
    // SYSTEM_PERMISSIONS = "System_Permissions",
    DatabaseTables["SYSTEM_ROLE_PERMISSIONS"] = "System_Role_Permissions";
    // SYSTEM_ROLE_PERMISSION_MAPPING = "System_Role_Permission_Mapping",
    // CUSTOM_ROLE = "Custom_Role"
    //notifications
    DatabaseTables["NOTIFICATIONS"] = "Notifications";
    DatabaseTables["NOTIFICATION_TO_USERS"] = "Notification_To_Users";
})(DatabaseTables || (exports.DatabaseTables = DatabaseTables = {}));
var DTBA;
(function (DTBA) {
    DTBA["USERS"] = "u";
    DTBA["COMPANY"] = "c";
    DTBA["ADMIN_EMAIL"] = "ae";
    DTBA["ORDERS"] = "o";
    DTBA["ADMIN_LOGS"] = "al";
    DTBA["ORGANIZATION_LICENSE"] = "ol";
    DTBA["SAMPLE_SPECIFICATIONS"] = "css";
    DTBA["SAMPLE_SPECIFICATION_DIRECTORY"] = "ssd";
    DTBA["SAMPLE_SPECIFICATION_READING_FILE"] = "ssrf";
    DTBA["SAMPLE_SPECIFICATION_READING_INFO"] = "ssri";
    DTBA["CLIENTS"] = "cl";
    DTBA["SAMPLES"] = "cs";
    DTBA["SAMPLE_INSTANCE"] = "csi";
    DTBA["SAMPLE_TEST_BATCH"] = "stb";
    DTBA["SAMPLE_TEST_BATCH_ASSIGNED_USERS"] = "stbau";
    DTBA["SAMPLE_TEST_BATCH_COMMENTS"] = "stbc";
    DTBA["CLIENT_ORGANIZATION"] = "co";
    DTBA["TEST_METHODS"] = "ctm";
    DTBA["BATCH_REPORT_FILES"] = "cbrf";
    //reconstructions
    DTBA["COMPANY_TEST_CATEGORIES"] = "ctc";
    DTBA["COMPANY_SAMPLE_MATRIX"] = "csm";
    DTBA["COMPANY_TEST_HIERARCHY_NODES"] = "cthn";
    DTBA["COMPANY_TEST_PACKAGE"] = "ctp";
    DTBA["COMPANY_TEST_PACKAGE_TESTS"] = "ctpt";
    DTBA["COMPANY_SAMPLE_ADDITIONAL_INFO_FIELDS"] = "csaif";
    DTBA["SAMPLE_ADDITIONAL_INFO_MAPPING"] = "caim";
    DTBA["SAMPLE_INSTANCE_ADDITIONAL_INFO_MAPPING"] = "siaim";
    DTBA["SAMPLE_INSTANCE_TEST_AND_BATCH_ASSIGNMENT"] = "sitaba";
    DTBA["COMPANY_BATCH_TYPES"] = "cbt";
    DTBA["COMPANY_BATCH_TYPE_TEST_CATEGORY_MAPPING"] = "cbttcm";
    DTBA["COMPANY_BATCH_TYPE_HIERARCHY_TEST_NODE_MAPPING"] = "cbthnm";
    DTBA["COMPANY_BATCH_TYPE_TEST_GROUP_OPTION_NODE_MAPPING"] = "cbttgonm";
    DTBA["ANALYST_CUSTOM_GROUP"] = "acg";
    DTBA["ANALYST_GROUP_BATCH_PERMISSION_ASSIGNMENT"] = "agbpa";
    DTBA["ANALYST_GROUP_PERMITTED_OTHER_TEST_CATEGORIES"] = "agpotc";
    //labels
    DTBA["COMPANY_TEST_LABELS"] = "ctl";
    DTBA["COMPANY_TEST_LABEL_SETTINGS"] = "ctls";
    DTBA["COMPANY_TEST_LABEL_SECONDARY_LABELS"] = "ctlsl";
    DTBA["COMPANY_TEST_LABEL_PACKAGE_ASSIGNMENT"] = "ctlpa";
    //to be removed
    // COMPANY_TEST_LABEL_HIERARCHY_NODE_MAPPING_PACKAGE = "ctlhnmp",
    // COMPANY_TEST_LABEL_PACKAGE_HIERARCHY_NODE_MAPPING = "ctlphnm",
    //results + expectations
    DTBA["COMPANY_TEST_RESULT_UNITS"] = "ctru";
    DTBA["COMPANY_RESULT_UNIT_ASSIGNMENT"] = "crua";
    DTBA["COMPANY_TEST_RESULT_FIELDS"] = "ctrf";
    DTBA["COMPANY_TEST_EXPECTATION_FIELDS"] = "ctef";
    DTBA["TEST_EXPECTATIONS"] = "te";
    DTBA["COMPANY_HIERARCHY_NODE_MAPPING_PACKAGE"] = "chnmp";
    DTBA["COMPANY_PACKAGE_HIERARCHY_NODE_MAPPING"] = "cphnm";
    DTBA["COMPANY_TEST_RESULT_PACKAGE_ASSIGNMENT"] = "ctrpa";
    //workflows
    DTBA["COMPANY_TESTING_WORKFLOW"] = "ctw";
    DTBA["COMPANY_TESTING_WORKFLOW_BATCH_TYPE_ASSIGNMENT"] = "ctwbta";
    DTBA["COMPANY_TESTING_WORKFLOW_STEPS"] = "ctws";
    DTBA["COMPANY_TESTING_WORKFLOW_TRANSITIONS"] = "ctwt";
    DTBA["COMPANY_TESTING_WORKFLOW_INFO_HIERARCHY_NODES"] = "ctwifn";
    DTBA["COMPANY_TESTING_WORKFLOW_INFO_NODES_RENDER_CONDITIONS"] = "ctwinrc";
    DTBA["COMPANY_TESTING_WORKFLOW_INFO_FIELDS"] = "ctwif";
    DTBA["COMPANY_WORKFLOW_NODE_INFO_ASSIGNMENT"] = "cwnia";
    DTBA["COMPANY_TESTING_WORKFLOW_INFO_OPTIONS"] = "ctwio";
    DTBA["BATCH_WORKFLOW_SIGNATURE"] = "bws";
    DTBA["BATCH_INSTANCE_LAB_WORKFLOW_INFO"] = "bilfi";
    //formulas
    DTBA["COMPANY_RESULT_CALCULATION_FORMULA"] = "crcf";
    DTBA["COMPANY_RESULT_CALCULATION_FORMULA_COMPONENTS"] = "crcfc";
    DTBA["COMPANY_WORKFLOW_RESULT_FORMULA_ASSIGNMENT"] = "cwrfa";
    DTBA["TEST_RESULTS"] = "tr";
    DTBA["TEST_RESULT_PACKAGE"] = "trp";
    //spec readings
    DTBA["COMPANY_SAMPLE_SPECIFICATION_HEADERS"] = "cssh";
    DTBA["COMPANY_SAMPLE_SPECIFICATION_ROW"] = "cssr";
    //permissions
    // SYSTEM_PERMISSIONS = "sp",
    DTBA["SYSTEM_ROLE_PERMISSIONS"] = "srp";
    // SYSTEM_ROLE_PERMISSION_MAPPING = "srpm",
    // CUSTOM_ROLE = 'cr',
    DTBA["NOTIFICATIONS"] = "n";
    DTBA["NOTIFICATION_TO_USERS"] = "ntu";
})(DTBA || (exports.DTBA = DTBA = {}));
exports.USER_TEMPLATE = {
    userId: "",
    companyId: "",
    userName: "",
    passwordSet: false,
    userRoleId: "",
    firstName: "",
    lastName: "",
    avatarUrl: "",
    email: "",
    isTestUser: false,
    // Optional fields — included as undefined or defaults
    hashedPassword: undefined,
    accessToken: undefined,
    analystCustomGroupId: undefined,
    locked: true,
    inserted: undefined,
};
exports.SAMPLE_TEST_BATCH_COMMENTS_TEMPLATE = {
    commentId: "",
    companyId: "",
    testBatchId: "",
    userId: "",
    comment: "",
    inserted: undefined,
};
exports.SYSTEM_ROLE_PERMISSIONS_TEMPLATE = {
    /* Identity */
    roleId: "",
    displayName: "",
    roleKey: constants_1.SystemRole.ANALYST,
    administrativeLevel: 0,
    limitedBatchAccess: permissions_1.BatchAccessLevel.ASSIGNED_ONLY,
    /* =====================
       Workflow
       ===================== */
    workflow_updateInfo: false,
    workflow_transition: false,
    workflow_editStep: false,
    /* =====================
       Client Orgs
       ===================== */
    clientOrgs_list: false,
    clientOrgs_create: false,
    clientOrgs_update: false,
    clientOrgs_get: false,
    /* =====================
       Clients
       ===================== */
    clients_create: false,
    clients_update: false,
    /* =====================
       Client Portal Registration
       ===================== */
    clientPortal_getOrder: false,
    clientPortal_syncOrgClient: false,
    /* =====================
       Client Licenses
       ===================== */
    licenses_create: false,
    licenses_delete: false,
    /* =====================
       Orders
       ===================== */
    orders_list: false,
    orders_get: false,
    orders_create: false,
    orders_update: false,
    orders_updateStatus: false,
    orders_delete: false,
    orders_repEditClientInfo: false,
    /* =====================
       Sample Instances
       ===================== */
    sampleInstances_adminList: false,
    sampleInstances_adminGet: false,
    sampleInstances_analystList: false,
    sampleInstances_analystGet: false,
    /* =====================
       Sample Test Batches
       ===================== */
    batches_getDetails: false,
    batches_listOverview: false,
    batches_fetchInstances: false,
    batches_adminGenerate: false,
    batches_analystGenerate: false,
    batches_edit: false,
    batches_start: false,
    batches_updateStatus: false,
    batches_comment: false,
    /* =====================
       Samples
       ===================== */
    samples_updateInfo: false,
    samples_bulkImport: false,
    /* =====================
       Specifications
       ===================== */
    specs_upload: false,
    specs_download: false,
    specs_delete: false,
    specs_move: false,
    specs_create_reading: false,
    specs_create_reading_row_col: false,
    /* =====================
       Specifications Folders
       ===================== */
    specs_folders: false,
    /* =====================
       Test Labels
       ===================== */
    testLabels_list: false,
    /* =====================
       Users
       ===================== */
    users_list: false,
    users_listAnalysts: false,
    users_create: false,
    users_update: false,
    /* =====================
       Temp Password Integration
       ===================== */
    tempPassword_generate: false,
    /* =====================
       Logs
       ===================== */
    logs_search: false,
};
// export interface SystemPermission {
// 	id: string;
// 	permission: PermissionValue;
// 	inserted?: Date;
// }
// export interface SystemRolePermissionMapping {
// 	mappingId: string;
// 	roleId: string;
// 	permissionId: string;
// 	inserted?: Date;
// }
// export interface CustomRole {
// 	customRoleId: string;
// 	companyId: string;
// 	name: string;
// 	inserted?: Date;
// }
